import { render, staticRenderFns } from "./BibliographyTagDataList.vue?vue&type=template&id=cb23fc32&"
import script from "./BibliographyTagDataList.vue?vue&type=script&lang=ts&"
export * from "./BibliographyTagDataList.vue?vue&type=script&lang=ts&"
import style0 from "./BibliographyTagDataList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VCard,VDivider,VList,VListItem,VListItemContent,VListItemGroup,VListItemTitle})
